<template>
  <div class="custom-tooltip" data-qa-id="custom-tooltip-editable-col">
    <div class="tooltip-content">
      {{ !params.value ? 'No data available' : params.value }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomTooltip',
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { value } = props.params
    return {
      value
    }
  }
}
</script>

<style lang="scss">
.custom-tooltip {
  position: absolute;
  background-color: var(--md-color--white);
  font-family: var(--md-font-family--text-regular);
  font-size: var(--md-font-size--xs);
  font-weight: 400;
  line-height: var(--md-line-height--3xs);
  color: var(--md-color--spirits--900);
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0px 112px 228px 0px rgba(55, 73, 81, 0.12), 0px 25.017px 50.927px 0px rgba(55, 73, 81, 0.07),
    0px 7.448px 15.162px 0px rgba(55, 73, 81, 0.05);
  max-width: 215px;

  .custom-tooltip .tooltip-content {
    word-wrap: break-word;
  }
}
</style>
